import { SchedulerOwningEntityType } from '@/components/integration/nylas/scheduler/types'
import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { PublicMeetingTypeItem } from '@/types/responses/meeting-types'

export default new (class PublicMeetingTypeService {
  public async get(
    type: SchedulerOwningEntityType,
    owningEntityId: number | string,
  ): Promise<PublicMeetingTypeItem> {
    const endpoint = `${API_PATH_INTERNAL}/${type}/${owningEntityId}/meeting-type`

    const response = await apiService.get<PublicMeetingTypeItem>(endpoint)

    return response.data
  }
})()
